export default __webpack_public_path__ + "img/42.e30c588.svg";